module.exports = __webpack_public_path__ + "img/thumb_30.57b65b42.jpg";